/* istanbul ignore file */
import { Link } from 'react-router-dom';
import { SanitizedHtml } from 'framework/utils';
import { Container, Typography } from '@mui/material';
import { useAuthorizationAuth } from '../authorization/AuthorizationAuthContext';

interface Page403Props {
  location?: {
    state?: {
      htmlMessage?: string;
    };
  };
}

const Page403 = (props: Page403Props) => {
  const { location } = props;
  const { isAuthenticated, backLinkLabel } = useAuthorizationAuth();

  const getDefaultPageMessage = () => {
    return (
      <>
        You do not have a permission to do it.
        {isAuthenticated && (
          <>
            <br />
            You can go back to&nbsp;
            <Link to="/">{backLinkLabel}</Link>
          </>
        )}
      </>
    );
  };

  const getPageMessage = () => {
    if (location?.state?.htmlMessage) {
      return <SanitizedHtml html={location.state.htmlMessage} />;
    } else {
      return getDefaultPageMessage();
    }
  };

  return (
    <Container
      sx={{
        justifyContent: 'center',
        minHeight: 'calc(100vh - 90px)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography variant="display0" mr={3.75} sx={{ float: 'left' }} color="primary">
        403
      </Typography>
      <div>
        <Typography variant="h4" mb={1} pt={1.5}>
          Access denied.
        </Typography>
        <Typography color="textSecondary">{getPageMessage()}</Typography>
      </div>
    </Container>
  );
};

export default Page403;
